import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bcd0e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center table-responsive" }
const _hoisted_2 = { class: "table askus-table" }
const _hoisted_3 = ["width"]
const _hoisted_4 = {
  key: 0,
  class: "header-status"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 0,
  class: "date"
}
const _hoisted_8 = {
  key: 1,
  class: "my-1"
}
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AskusAttributeBadges = _resolveComponent("AskusAttributeBadges")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, _toDisplayString(_ctx.domainStore.translate('askus.question.title')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributesShownAsColumns, (attr) => {
            return (_openBlock(), _createElementBlock("th", {
              key: attr.id,
              width: attr.relation_data && attr.relation_data.column_width ? attr.relation_data.column_width : '200'
            }, _toDisplayString(attr.name), 9, _hoisted_3))
          }), 128)),
          (_ctx.canShowQuestionStatus)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Status"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "question-row",
            onClick: ($event: any) => (_ctx.openQuestion(question, question.id)),
            key: question.id
          }, [
            _createElementVNode("td", _hoisted_6, [
              _createTextVNode(_toDisplayString(question.title) + " ", 1),
              (_ctx.canShowQuestionDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.formattedDate(question.created, true)), 1))
                : _createCommentVNode("", true),
              (_ctx.attributesShownAsTags.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_AskusAttributeBadges, {
                      question: question,
                      attributes: _ctx.attributesShownAsTags
                    }, null, 8, ["question", "attributes"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.truncateAfterWord(question.content, 180)), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributesShownAsColumns, (attr) => {
              return (_openBlock(), _createElementBlock("td", {
                key: attr.id
              }, _toDisplayString(_ctx.getAttributeValueById(question, attr.id)), 1))
            }), 128)),
            (_ctx.canShowQuestionStatus)
              ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(question.status), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}